import { render } from "./adminNotesPanel.vue?vue&type=template&id=3e83182b&scoped=true"
import script from "./adminNotesPanel.vue?vue&type=script&lang=js"
export * from "./adminNotesPanel.vue?vue&type=script&lang=js"

import "./adminNotesPanel.vue?vue&type=style&index=0&id=3e83182b&scoped=true&lang=css"
import "./adminNotesPanel.vue?vue&type=style&index=1&id=3e83182b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e83182b"]])

export default __exports__